import React, { Component, Fragment } from 'react'
import { Form, Input, Button } from 'antd'
import { withTranslation } from 'react-i18next'
import _ from 'lodash'
import './form.scss'

class DiscussionForm extends Component {
  submitComment = () => {
    const {
      form,
      postComment,
      discussionId,
      discussionType,
      parentId
    } = this.props
    const value = form.getFieldValue('comment')

    if (value && value.trim() !== '') {
      postComment(discussionId, discussionType, parentId, value)
      form.setFieldsValue({ comment: '' })
    }
  }

  onPressEnter = e => {
    if (!e.shiftKey) {
      e.preventDefault()
      this.submitComment()
    }
  }

  getSmallProfileImage = image => {
    if (image) {
      const { link, resizes } = image
      return _.isEmpty(resizes) ? link : resizes.thumbnail
    }
    return ''
  }

  render() {
    const {
      user,
      form: { getFieldDecorator, getFieldValue },
      t,
      posting,
      isDisabled
    } = this.props

    const commentValue = getFieldValue('comment') || ''
    const isSendDisabled =
      posting || isDisabled || commentValue.trim().length === 0

    return (
      <Fragment>
        <Form className="discussion-form">
          <Form.Item>
            {getFieldDecorator('comment')(
              <Input.TextArea
                name="comment"
                placeholder={t('discussion:join_discussion')}
                style={{
                  paddingLeft: '60px',
                  backgroundImage: `url(${this.getSmallProfileImage(
                    user.info.avatar
                  )})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '10px 10px',
                  backgroundSize: '40px auto'
                }}
                disabled={posting || isDisabled}
                onPressEnter={this.onPressEnter}
                autoSize={{ minRows: 3 }}
              />
            )}
          </Form.Item>

          {/* Send Button */}
          <Form.Item
            style={{ textAlign: 'right', marginBottom: 0 }}
            className="discussion-send-btn"
          >
            <Button
              type="primary"
              onClick={this.submitComment}
              loading={posting}
              disabled={isSendDisabled}
            >
              {t('v3:send')}
            </Button>
          </Form.Item>
        </Form>
      </Fragment>
    )
  }
}

export default Form.create()(withTranslation()(DiscussionForm))
